import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Divider, message } from 'antd';
import { LikeOutlined } from '@ant-design/icons';

import { getExamRecord, getListRecord, getUserInfo, checkExam } from './api';
import StarBig from '../../assets/images/p_img_star1.png';
import StarSmall from '../../assets/images/p_img_star2.png';
import TestPass from '../../assets/images/test_pass.png';
import TestFail from '../../assets/images/test_fail.png';
import Logo from "../../assets/images/qingcloud_new.svg";

import './index.less';

function ExamResult() {
  const [recordInfo, setRecordInfo] = useState({
    grade: 0,
    gradePass: 0
  });
  const [recordList, setRecordList] = useState([]);
  const history = useHistory();
  const urlParams: { examId: string, recordId: string, mark: string } = useParams();
  const userinfo = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify({})) || {};

  useEffect(() => {
    getRecord();
    getRecordList();
  }, []);

  function getRecord() {
    getExamRecord({ id: urlParams.recordId }).then((res: any) => {
      if (res && res.code === 0) {
        const { data } = res;
        setRecordInfo(data);
      } else {
        res && message.error(res.msg || '获取考试记录失败！');
      }
    })
  }

  function getRecordList() {
    const userinfo = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify(null)) || {};
    getListRecord({ page: 1, limit: 10, examID: urlParams.examId, sort: 'grade', user_id: userinfo.id }).then((res: any) => {
      if (res && res.code === 0) {
        const { records } = res.data;
        let ids: string[] = [];
        records.map((item: any) => {
          ids.push(item.userID);
          return item;
        });
        let _ids: any = Array.from(new Set(ids));
        getUserInfo({ id: _ids.join(',') }).then((response: any) => {
          if (response && response.code === 0) {
            const { user = [] } = response.data;
            if (user && user.length > 0) {
              for (let i = 0; i < records.length; i++) {
                for (let j = 0; j < user.length; j++) {
                  if (records[i].userID === user[j].id) {
                    records[i].username = user[j].userName;
                    records[i].employeeEmail = user[j].employeeEmail;
                  }
                }
              }
            }
            setRecordList(records || []);
          }
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }

  function viewExam() {
    history.push(`/manmade_exam_check/view/${urlParams.recordId}`);
  }

  function repeatExam() {
    checkExam({ examID: urlParams.examId, user_id: userinfo.id }).then((res: any) => {
      if (res && res.code === 0) {
        history.push(`/before_exam/${urlParams.examId}`);
      } else {
        res && message.error(res.msg || "暂不能考试!");
      }
    })
  }

  function goHome() {
    history.push('/');
  }

  const isPassTest = recordInfo.grade >= recordInfo.gradePass;

  return (
    <div className="exam-result">
      <div className="exam-result-head">
        <div className="head">
          <div className="head-left" onClick={goHome}>
            <div className="logo">
              {/* <img src="https://qxp-public.pek3b.qingstor.com/QingCloud-Logo202104%402x.png" alt="青云" /> */}
              <img src={Logo} alt="青云" />
              <span className="line">|</span>
              <span className="text">合作伙伴支持平台</span>
            </div>
          </div>
          <div className="head-right">{userinfo.employee_name}</div>
        </div>
      </div>
      <div className="exam-result-content">
        <div className="content">
          <div className="content_result">
            <img src={isPassTest ? TestPass : TestFail} alt="" />
          </div>
          <div className="info">
            <div className="title">{userinfo.employee_name}</div>
            <div className="num">
              <span className="star-big">
                <img src={StarBig} alt="" />
              </span>
              <span className="grade">{recordInfo.grade.toFixed(1)}</span>
              <span>分</span>
              <span className="star-small">
                <img src={StarSmall} alt="" />
              </span>
            </div>
            <div className="text">感谢您的作答！</div>
            {/* <div className="fen">16.3%</div>
            <div className="lv">
              <LikeOutlined />
              正确率</div> */}
          </div>
          <div className="result">
            <div className="head">
              <Divider plain>排行榜</Divider>
            </div>
            <div className="title">
              <div>名次</div>
              <div>用户名</div>
              <div>账号</div>
              <div>分数</div>
            </div>
            <ul>
              {
                recordList.map((item: any, index) => {
                  return (
                    <li key={item.id}>
                      <div>{index + 1}</div>
                      <div>{item.username}</div>
                      {
                        item.employeeEmail && (
                          <div>{item.employeeEmail.substring(0, 4)}****{item.employeeEmail.substring(item.employeeEmail.length - 6)}</div>
                        )
                      }
                      <div>{item.grade && item.grade.toFixed(1)}</div>
                    </li>
                  )
                })
              }
            </ul>
          </div>
          <div className="btn">
            <div className="button" onClick={goHome}>返回首页</div>
            {isPassTest && <div className="button" onClick={viewExam}>查看试卷</div>}
            <div className="button" onClick={repeatExam}>再考一次</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExamResult;
